import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function SmallPrint({ className }) {
  return (
    <p className={`text-muted paragraph-small ${className}`}>
      <FormattedMessage
        id="checkout.smallprint"
        defaultMessage="Less than 1% of orders are flagged for manual authorization. This process can take up to one working day, but orders are normally reviewed within a few hours."
      />
    </p>
  );
}

SmallPrint.propTypes = {
  className: PropTypes.string,
};

SmallPrint.defaultProps = {
  className: 'mt-2 mb-5',
};
